import { message } from "antd";
import nanoid from "nanoid";
// eslint-disable-next-line
import router from "umi/router";
import moment from "moment";
import {
  add,
  getAppData,
  getMold,
  saveDraft
} from "../../../../services/safeClock/create";
import { queryOutboxDetail } from "../../../../services/safeClock/detail";
import { getComposeUrl } from "../../../../utils/common";

// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = "" }) => {
  return put({
    type: "save",
    payload: {
      spinProps: {
        spinning,
        tip
      }
    }
  });
};

const initState = () => {
  return {
    activeKey: "1",
    type: "create",
    id: null,
    publishModalVisible: false,
    formData: {
      message: "", // 通知内容
      annexGroupId: "",
      fileCount: 0,
      receiptStatus: 0, // 是否选择回执单
      receiptQuestions: null,
      receiptTemplateId: "",
      receiptTitle: "",
      receiptContent: "",
      senderName: "", // 发送人署名
      senderType: "dept",
      title: "", // 通知标题
      /**
       * 附件信息列表
       * format    string  附件格式
       * name    string  文件名
       * size    number  文件大小
       * url   string   url地址
       */
      fileList: [],
      receiveUserTemplate: "", // 选人组件模板id
      btnStatus: true, // 是否可以禁用
      isCounty: 1, // 是否为区县，0=否，1=是
      subContent: "", // message 的精简，20个字符
      senderDate: moment(new Date(), "YYYY.MM.DD").add(2, "hours"), // 定时发送日期
      senderTime: moment(new Date(), "HH:mm:ss").add(2, "hours"), // 定时发送时间
      pushSetting: 1,
      coverInfo: {}, // 选中封面信息
      selectUserType: "user",
      issueAuto: ""
    },
    requiredFields: ["message", "timer", "title", "receiveUserTemplate"], // 必填字段数组
    // 加载状态
    spinProps: {
      spinning: false,
      tip: "加载中..."
    },
    questionList: [], // 问卷收集列表
    moldList: [], // 通知类型列表
    coverList: [], // 封面列表
    moldDataList: [], // 通知类型和封面数据
    selectMold: [], // 选中类型
    appData: [] // 可发送应用列表
  };
};

export default {
  namespace: "safeClockCreate",

  state: initState(),

  effects: {
    *fetchDetails({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const response = yield call(queryOutboxDetail, payload);

        const {
          annexList,
          sendTime,
          receiveUserTemplate,
          isSetTimer,
          receiptStatus,
          receiptTemplateId,
          question,
          receiptQuestions,
          selectUserType,
          ...otherProps
        } = response;

        const { type } = payload;

        // 转换时间
        let newTimer =
          type === "reEdit" || sendTime === null ? new Date() : sendTime;
        if (type === "reEdit" || sendTime === null) {
          newTimer = moment(new Date()).add(2, "hours");
        } else {
          newTimer = moment(new Date(newTimer));
        }
        const senderDate = moment(newTimer, "YYYY.MM.DD");
        const senderTime = moment(newTimer, "HH:mm:ss");

        // 转换附件格式列表
        const fileList = (annexList || []).map(file => {
          const { name, size, url } = file;

          return {
            uid: nanoid(),
            type: "edit",
            name,
            status: "done",
            response: undefined,
            size,
            url
          };
        });

        const { formData: initFormData } = initState();
        const formData = Object.assign({}, initFormData, {
          ...otherProps,
          fileList,
          isSetTimer:
            type === "reEdit" || type === "create"
              ? initFormData.isSetTimer
              : isSetTimer,
          receiptStatus: receiptStatus ? 1 : 0,
          receiptTemplateId,
          timer: newTimer,
          senderDate,
          senderTime,
          selectUserType,
          btnStatus: false,
          receiptQuestions:
            typeof receiptQuestions === "string"
              ? JSON.parse(receiptQuestions)
              : receiptQuestions,
          question
        });

        yield put({
          type: "saveFormData", // 在saveFormData方法中修改btnStatus状态
          payload: {
            formData
          }
        });

        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            },
            type: "edit"
          }
        });
        return Promise.resolve(formData);
      } catch (error) {
        yield setSpinProps({ put });
        message.error(error.msg || "网络错误，请重试");
        return Promise.reject();
      }
    },
    *getMold(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const moldDataList = yield call(getMold);

        const defaultMold = moldDataList[0];
        const { moldId, moldName, coverList } = defaultMold;

        // type:1-模版，2-自定义
        const { coverId, url, coverName } =
          coverList.find(coverItem => coverItem.type === 1) || {};
        yield put({
          type: "saveFormData",
          payload: {
            // senderName: userInfo.orgName,
            moldId,
            moldName,
            coverInfo: {
              coverId,
              coverName,
              coverUrl: url,
              newCoverFlag: 0
            }
          }
        });

        yield put({
          type: "save",
          payload: {
            moldDataList,
            moldList: moldDataList.map(mold => ({
              value: `${mold.moldId},${mold.moldName}`,
              label: `${mold.moldName}通知`
            })),
            coverList,
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.resolve();
      } catch (error) {
        yield setSpinProps({ put });
        message.error((error && error.msg) || "网络错误，请重试");
        return Promise.reject();
      }
    },
    *getAppData(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const appData = yield call(getAppData);

        yield put({
          type: "save",
          payload: {
            appData,
            spinProps: {
              spinning: false
            }
          }
        });
      } catch (error) {
        yield setSpinProps({ put });
        message.error((error && error.msg) || "网络错误，请重试");
      }
    },
    *fetchSaveDraft({ payload }, { call }) {
      try {
        const data = yield call(saveDraft, payload);

        return Promise.resolve(data);
      } catch (error) {
        message.error(error.msg || "网络错误，请重试");
        return Promise.reject();
      }
    },
    *fetchSubmit({ payload }, { call, put }) {
      try {
        const { fileList, eduTagPush } = payload;

        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const annex = (fileList || []).map(file => {
          const { name, size, url } = file;
          const format = name.substring(name.lastIndexOf(".") + 1) || "";
          return {
            format,
            name,
            size,
            url
          };
        });

        const params = {
          ...payload,
          annex
        };

        // 判断提交后第一个处理人是否为拟稿人,如果是，则后段返回工作流url（移动端），直接跳转到工作流审批页面
        // 示例 //m.xiaoyuanhao.com/micro/app/workFlow/form?flowCode=PAZSPLC1586262230175&taskId=19840&corpid=wwef5a06cd2931632c&returnUrl=
        const url = yield call(add, params);

        message.success("提交成功");

        if (url) {
          const [href, taskId] = url.split("&");
          const flowCode = href.split("?")[1];
          router.replace(
            `${getComposeUrl(
              "/safeClock/approve/form"
            )}?${flowCode}&${taskId}&pageSource=safeClock`
          );
        } else {
          router.push(
            getComposeUrl(`/safeClock/${eduTagPush ? "eduTagPush" : "outbox"}`)
          );
        }
        yield put({
          type: "reset"
        });
      } catch (error) {
        yield setSpinProps({ put });
        message.error(error.msg || "网络错误，请重试");
      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    // 保存表单数据
    saveFormData(state, { payload }) {
      const { formData, requiredFields } = state;
      const { formData: newFormData = {}, ...otherProps } = payload;

      const data = Object.assign(
        {},
        { ...formData, ...newFormData, ...payload }
      );
      const { isSetTimer, senderDate, senderTime } = data;
      let isHasNullKey = false;

      // 遍历查找有否有必填项未填
      for (
        let index = 0, len = requiredFields.length;
        index < len;
        index += 1
      ) {
        const key = requiredFields[index];
        const element = data[key];

        if (
          !element ||
          (typeof element === "string" &&
            element.replace(/^\s+|\s+$/g, "").length === 0) ||
          element.length === 0
        ) {
          isHasNullKey = true;
          break;
        }

        // 判断是否有定时发送功能
        if (
          key === "timer" &&
          isSetTimer === 1 &&
          senderDate === null &&
          senderTime === null
        ) {
          isHasNullKey = true;
          break;
        }
      }

      // 判断按钮可点击状态
      data.btnStatus = isHasNullKey;

      return {
        ...state,
        ...otherProps,
        formData: data
      };
    },
    reset() {
      return { ...initState() };
    }
  }
};
